import { render, staticRenderFns } from "./doTest.vue?vue&type=template&id=dccf15d6&scoped=true&"
import script from "./doTest.vue?vue&type=script&lang=js&"
export * from "./doTest.vue?vue&type=script&lang=js&"
import style0 from "./doTest.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./doTest.vue?vue&type=style&index=1&id=dccf15d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccf15d6",
  null
  
)

export default component.exports